/**
 * 模式列表
 * 0：兼容模式，1：安全模式
 */
export enum AuthModeE {
    COMPATIBLE_MODE = 0,
    SAFE_MODE = 1
}

export const AuthModePermissionE = {
    '@vstore_R': {
        [AuthModeE.COMPATIBLE_MODE]: 'base',
        [AuthModeE.SAFE_MODE]: 'vstore_R',
    },
    '@batch_configuration_R': {
        [AuthModeE.COMPATIBLE_MODE]: 'base',
        [AuthModeE.SAFE_MODE]: 'batch_configuration_R',
    },
    '@workload_type_R_lun_R':{
        [AuthModeE.COMPATIBLE_MODE]: 'lun_R',
        [AuthModeE.SAFE_MODE]: 'workload_type_R',
    },
    '@workload_type_fs_R':{
        [AuthModeE.COMPATIBLE_MODE]: 'file_system_R',
        [AuthModeE.SAFE_MODE]: 'workload_type_R',
    },
    '@ndmp_service_W':{
        [AuthModeE.COMPATIBLE_MODE]: 'file_system_W',
        [AuthModeE.SAFE_MODE]: 'ndmp_service_W',
    },
    '@ndmp_service_R':{
        [AuthModeE.COMPATIBLE_MODE]: 'file_system_R',
        [AuthModeE.SAFE_MODE]: 'ndmp_service_R',
    },
    '@hyper_cdp_R': {
        [AuthModeE.COMPATIBLE_MODE]: 'base',
        [AuthModeE.SAFE_MODE]: 'hyper_cdp_R',
    },
    '@hyper_cdp_W': {
        [AuthModeE.COMPATIBLE_MODE]: 'base',
        [AuthModeE.SAFE_MODE]: 'hyper_cdp_W',
    },
    '@audit_strategy_R': {
        [AuthModeE.COMPATIBLE_MODE]: 'file_system_R',
        [AuthModeE.SAFE_MODE]: 'audit_strategy_R',
    },
    '@audit_strategy_W': {
        [AuthModeE.COMPATIBLE_MODE]: 'file_system_W',
        [AuthModeE.SAFE_MODE]: 'audit_strategy_W',
    },
};
